import { Injectable } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class FormCocinaService {

  dishForm!: FormGroup;
  menuForm!: FormGroup;
  insumoForm!: FormGroup;

  constructor(private fb: FormBuilder) { }

  getDishForm(){
    return this.dishForm = this.fb.group({
      nombre: new FormControl('', {nonNullable: true}),
      categoria: new FormControl('', {nonNullable: true}),
      observaciones: new FormControl('', {nonNullable: true}),
    });
  }

  getInsumoForm(){
    return this.insumoForm = this.fb.group({
      nombre: new FormControl('', {nonNullable: true}),
      cantidad: new FormControl('', {nonNullable: true}),
      unidadMedida: new FormControl('', {nonNullable: true}),
    });
  }

  getMenuForm(){
    return this.menuForm = this.fb.group({
      nombre: new FormControl('', {nonNullable: true}),
      descripcion: new FormControl('', {nonNullable: true}),
    });
  }

}
